import React from 'react';
import { ReviewContactDetailsView } from 'pages/components';

const ARContactsNewReview = (props) => (
  <ReviewContactDetailsView {...props} />
);

export default ARContactsNewReview;
